import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {PlatformConfig} from './platform-config';
import {GlobalVariable} from '../global';

@Injectable()
export class ConfigLoaderService {

  private platformConfig: PlatformConfig;

  constructor(private http: HttpClient) {
  }

  loadPlatformConfig() {
    const platformConfigAge = new Date().getTime() - (+window.localStorage.getItem('platformConfigDate') );
    // old config timestemp check platformConfigAge > (24 * 60 * 60 * 1000)
    if ( platformConfigAge ) {
      return new Promise((resolve, reject) => {
        this.refreshPlatformConfig().subscribe(
          (platformConfig: PlatformConfig) => {
            resolve();
          }, (error: HttpErrorResponse) => {
            
            alert('SERVER CONNEXION ERROR');
          }
        );
      });
    } else {
      return new Promise((resolve, reject) => {
        this.platformConfig = JSON.parse(window.localStorage.getItem('platformConfig'));
        resolve();
      });
    }
  }

  getPlatformConfig(): PlatformConfig {
    return this.platformConfig;
  }

  refreshPlatformConfig() {
    return this.http.get(GlobalVariable.PUBLIC_API_URL + '/platform-config', {
    })
      .map(
        (response: PlatformConfig) => {
          this.platformConfig = response;
          window.localStorage.setItem('platformConfig', JSON.stringify(response));
          window.localStorage.setItem('platformConfigDate', '' + new Date().getTime());
          return response;
        }
      );
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/app-loader/config-loader.service.ts